import React from 'react'

import { BaseIconProps, IconSizes, IconColors } from '../base'

const Send: React.FC<BaseIconProps> = React.forwardRef(
  ({ size = 'md', color = 'default', className }, ref) => (
    <svg
      ref={ref}
      className={className}
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.21194 3.44699C0.855675 2.81831 0.955625 2.03415 1.45858 1.51199C1.96154 0.989822 2.75048 0.851134 3.40541 1.16976L24.544 11.7599C24.8237 11.9002 24.9998 12.1834 24.9998 12.4929C24.9998 12.8023 24.8237 13.0855 24.544 13.2258L3.40541 23.8302C2.75048 24.1489 1.96154 24.0102 1.45858 23.488C0.955625 22.9658 0.855675 22.1817 1.21194 21.553L6.83512 12.4923L1.21194 3.44699Z"
        stroke={IconColors[color]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0001 12.4923H6.82983"
        stroke={IconColors[color]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

export default Send
